import React from "react";
import { motion } from "framer-motion";
import { Icon } from "@iconify/react";

const MobileFeatureView = ({
  inView,
  fadeInUp,
  featureIcons,
  featureTexts,
  images,
}) => {
  return (
    <div className="df-terafac-live df-feature-column d-flex flex-column flex-lg-row">
      <motion.div
        className="df-feature-first-column col-lg-5"
        initial="hidden"
        animate={inView ? "visible" : "hidden"}
        variants={fadeInUp}
        transition={{ duration: 1, delay: 0.2 }}
      >
        <div className="first-pic-div"></div>
        <div className="second-pic-div relative">
          <img
            className="feature-first-pic shift-left"
            src={images.abbRobot}
            alt="ABB Robot"
          />
          <img
            className="feature-second-pic absolute-second"
            src={images.pnc}
            alt="PNC System"
          />
          <img
            className="feature-third-pic absolute-third"
            src={images.operator}
            alt="Operator"
          />
        </div>
      </motion.div>
      <div className="feature-second-column col-lg-7">
        {featureTexts.map((text, index) => (
          <div
            key={index}
            className={`col-10 features-div ${
              index % 2 === 1 ? "offset-2 ms-4" : "ms-0"
            }`}
          >
            <div className="icon-container white-icon">
              <Icon icon={featureIcons[index]} width={25} height={25} />
            </div>
            <h2>{text}</h2>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MobileFeatureView;
